import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationsDropdownComponent} from './notifications-dropdown.component';
import {RouterModule} from '@angular/router';
import {AppModule} from '../../../app.module';
import {TimeAgoModule} from '../../pipes/time-ago/time-ago.module';


@NgModule({
  declarations: [
    NotificationsDropdownComponent,
  ],
  exports: [
    NotificationsDropdownComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TimeAgoModule,
  ],
})
export class NotificationsDropdownModule {
}
